import { render } from "./Settings.vue?vue&type=template&id=089f8576&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=089f8576&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-089f8576"

export default script